import React from "react";
import { Link } from "react-router-dom";
import ComingSoonIntegration from "./ComingSoonIntegration";
import { INTEGRATIONS_HUB } from "./paths";

const XeroIntegration: React.FC = () => (
  <ComingSoonIntegration
    name="Xero"
    logo="X"
    logoBg="#13b5ea"
    connectLabel="Connect Xero"
    subtitle="Let agents query invoices, contacts, and accounts. This is a tool integration — not a data source. Connect will use OAuth; secrets never go in Agent Builder chat."
    whatAgentsDo={
      <>
        After connect, associated agents can look up invoices and contacts in a
        bounded actions loop (same associate → describe → execute pattern as
        data sources). Retrieval indexes stay on{" "}
        <Link to={`${INTEGRATIONS_HUB}?category=data_source`}>
          Data sources
        </Link>
        .
      </>
    }
  />
);

export default XeroIntegration;
